<template>
    <div class="row">
      <h4 class="required">Select Category & Reason</h4>
        <div class="col-md-6">
            <el-select
                v-model="reasonCodeModel"
                placeholder="Select"
                class="form-control form-control"
                id="reasonGroup"
                name="reasonGroup"
                @change="changeReasonGroup()"
                :disabled="disabled"
            >
              <el-option
                  v-for="item in reasonGroup"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
              ></el-option>
            </el-select>
            <p v-if="!$v.reasonCode.required" class="text-danger">
                Please select a reason code
            </p>
        </div>
      <div class="col-md-6">
        <el-select
            v-model="reasonCodeDetailModel"
            placeholder="Select"
            class="form-control form-control"
            id="couponGroupDetail"
            name="couponGroupDetail"
            :disabled="disabled"
        >
          <el-option
              v-for="item in reasonGroupDetail"
              :key="item"
              :label="item"
              :value="item"
          ></el-option>
        </el-select>
      </div>
    </div>
</template>

<script>
  import {mapMutations, mapState} from 'vuex';
  import {
    ORDER_RETURN_SET_REASON_CODE, ORDER_RETURN_SET_REASON_CODE_DETAIL,
  } from '../../../store/modules/order/return/types';
  import {RETURN_REASON_CODES, RETURN_REASON_CODE_DETAILS} from '../../../lang/en/constants';

  export default {
    name: 'OrderReturnReasonCode',
    inject: ['$v'],
    props: {
      disabled: {
        required: false,
        default: false,
        type: Boolean,
      },
    },
    computed: {
      ...mapState({
        reasonCode: state => state.orderReturn.reasonCode,
        reasonCodeDetail: state => state.orderReturn.reasonCodeDetail
      }),
      reasonCodeModel: {
        get() {
          return this.reasonCode;
        },
        set(value) {
          this.setReasonCode(value);
        },
      },
      reasonCodeDetailModel: {
        get() {
          return this.reasonCodeDetail;
        },
        set(value) {
          this.setReasonCodeDetail(value);
        }
      }
    },
    methods: {
      ...mapMutations({
        setReasonCode: ORDER_RETURN_SET_REASON_CODE,
        setReasonCodeDetail: ORDER_RETURN_SET_REASON_CODE_DETAIL
      }),
      changeReasonGroup() {
        var key = this.reasonCode;
        this.reasonGroupDetail = RETURN_REASON_CODE_DETAILS[
            key
        ];
        this.setReasonCodeDetail(this.reasonGroupDetail[0]);
      }
    },
    data() {
      return {
        reasonGroup: RETURN_REASON_CODES,
        reasonGroupDetail: []
      };
    }
  };
</script>
